export const FISCAL_IVA_OPTIONS = [
  { value: 'RI', label: 'Responsable Inscripto' },
  { value: 'MONOTRIBUTO', label: 'Monotributo' },
  { value: 'EXENTO', label: 'Exento' },
  { value: 'CF', label: 'Consumidor Final' },
  { value: 'NO_CATEGORIZADO', label: 'No categorizado' },
  { value: 'OTRO', label: 'Otro' },
];

export function formatCuitInput(value = '') {
  const digits = String(value).replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 2) return digits;
  if (digits.length <= 10) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
  return `${digits.slice(0, 2)}-${digits.slice(2, 10)}-${digits.slice(10)}`;
}

export function formatCuitDisplay(value = '') {
  const digits = String(value).replace(/\D/g, '');
  if (digits.length !== 11) return String(value || '').trim();
  return formatCuitInput(digits);
}

/** Client-side validation aligned with backend validate_fiscal_profile_input. */
export function validateFiscalProfileForm({ fiscalCuit, fiscalLegalName, fiscalIvaCondition }) {
  const cuitDigits = String(fiscalCuit || '').replace(/\D/g, '');
  const name = String(fiscalLegalName || '').trim();
  const condition = String(fiscalIvaCondition || '').trim().toUpperCase();

  if (cuitDigits.length !== 11) {
    return 'CUIT inválido — debe tener 11 dígitos';
  }
  if (name.length < 2 || name.length > 120) {
    return 'Razón social inválida';
  }
  if (!FISCAL_IVA_OPTIONS.some((opt) => opt.value === condition)) {
    return 'Condición ante IVA inválida';
  }
  return null;
}

export const ENRICHMENT_SOURCE_COPY = {
  tenant_profile: 'Perfil tenant',
  qr: 'QR AFIP',
};
